import { createMotionComponent } from "../../../motion";
import { createDomVisualElement } from "../../dom/create-visual-element";
import { featureBundle } from "./feature-bundle";
export function createMotionComponentWithFeatures(Component, options) {
    return createMotionComponent(Component, options, featureBundle, createDomVisualElement);
}
//# sourceMappingURL=create.js.map